const StickyHeader = (() => {
    const DOM = {};

    const cacheDOM = () => {
        DOM.header = document.getElementsByClassName("header")[0];
        DOM.headerTopHeight = DOM.header.offsetTop;
    }

    const stickyHeader = () => {
        if (window.scrollY >= DOM.headerTopHeight) {
            document.body.style.paddingTop = DOM.header.offsetHeight + 'px';
            DOM.header.classList.add('js-sticky');
        } else {
            document.body.style.paddingTop = "0";
            DOM.header.classList.remove('js-sticky');
        }
    }

    const eventListeners = () => {
        window.addEventListener('scroll', stickyHeader);
    }

    const init = () => {
        cacheDOM();
        eventListeners();
    }

    return {
        init: init
    }
})();

export default StickyHeader;
